export const PO_CHANGE_REQUEST = {
  REQUEST: 'PO_CHANGE_REQUEST_REQUEST',
  SUCCESS: 'PO_CHANGE_REQUEST_SUCCESS',
  FAILURE: 'PO_CHANGE_REQUEST_FAILURE',
  REDIRECTED: 'PO_CHANGE_REQUEST_REDIRECTED'
};

export function poChangeRequest(payload) {
  return {
    payload,
    type: PO_CHANGE_REQUEST.REQUEST
  };
}

export function poChangeRequestSuccess(payload) {
  return {
    payload,
    type: PO_CHANGE_REQUEST.SUCCESS
  };
}

export function poChangeRequestFailure(payload) {
  return {
    payload,
    type: PO_CHANGE_REQUEST.FAILURE
  };
}

export function poChangeRequestRedirected() {
  return {
    type: PO_CHANGE_REQUEST.REDIRECTED
  };
}
